import { Drawer, Typography, Input, Divider } from 'antd';
import React from 'react';
import ClientJobHeader from './ClientJobHeader';
import '../../styles/components/MarketPlace/JobLocalitiesDrawer.scss';

const { Text } = Typography;

function JobLocalitiesDrawer({ jobData, openDrawer, onClose, localities, onSearchLocality }) {
  const onSearch = data => {
    onSearchLocality(data.target.value);
  };
  return (
    <div>
      <Drawer
        title={<ClientJobHeader jobData={jobData} />}
        placement="bottom"
        closable={false}
        onClose={onClose}
        open={openDrawer}
        key="bottom"
        height="80%"
      >
        <div className="localities-drawer-container">
          <Text className="drawer-title-text">Available work areas</Text>
          <Input placeholder="Search Location.." onChange={onSearch} />
          <div className="localities-section">
            {localities.map(item => {
              return (
                <div key={item}>
                  <div className="single-locality">
                    <img src="/images/location-icon.png" style={{ width: '25px' }} />
                    <div className="city-details-container">
                      <Text className="city-label">{item}</Text>
                    </div>
                  </div>
                  <Divider style={{ margin: '14px 0' }} />
                </div>
              );
            })}
          </div>
        </div>
      </Drawer>
    </div>
  );
}

export default JobLocalitiesDrawer;
